import React, { useState, useEffect, useContext } from "react";
import { BrowserRouter as Router, Link } from "react-router-dom";



export default function TaskView(props: any) {




  useEffect(() => {
    console.log("Activity On mount :", props);
  }, []);
  return (
    <div className="container">
    <div className="row">
      <div className="col-lg-6">
      <div className="card ">
                    <div className="card-body">
                      <h5 className="card-title">
                      Task Details</h5>

                      <p className="card-text pt-4">
                          <ul>files</ul>
                          <ul>notes</ul>
                          <ul>created</ul>
                          <ul>finished</ul>
                          <ul></ul>
                      </p>
      </div>
      </div>
  </div>
      <div className="col-lg-6">
        Company Details
      </div>
    </div>
  </div>
 
  );
}
